const SubHeader = ({ children, className }) => {
    return (<div className={`sub-header ${className}`}>
       
        {children}
    </div>);
}

export default SubHeader;